// Simple custom confirmation dialog
module.exports = function customConfirm(message, onConfirm, onCancel) {
	// Create overlay to block background interactions
	var overlay = document.createElement('div');
	overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: transparent; z-index: 9999;';
	
	// Create dialog container
	var container = document.createElement('div');
	container.style.cssText = 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10000;';
	
	// Create dialog box
	var dialog = document.createElement('div');
	dialog.style.cssText = 'background: white; padding: 24px; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.4); min-width: 320px; max-width: 520px; border: 2px solid #999; max-height: 80vh; overflow-y: auto;';
	
	// Create message
	var messageEl = document.createElement('p');
	messageEl.innerHTML = message;
	messageEl.style.cssText = 'margin: 0 0 24px 0; font-size: 15px; line-height: 1.6; white-space: pre-line; color: #333; word-wrap: break-word; overflow-wrap: break-word;';
	
	// Create button container
	var buttonContainer = document.createElement('div');
	buttonContainer.style.cssText = 'display: flex; justify-content: flex-end; gap: 12px; margin-top: 8px;';
	
	// Create Cancel button
	var cancelBtn = document.createElement('button');
	cancelBtn.textContent = 'Cancel';
	cancelBtn.style.cssText = 'padding: 10px 20px; border: 1px solid #ccc; background: white; border-radius: 4px; cursor: pointer; font-size: 14px; min-width: 80px; font-weight: 500; transition: all 0.2s;';
	cancelBtn.onmouseover = function() { this.style.background = '#f5f5f5'; this.style.borderColor = '#999'; };
	cancelBtn.onmouseout = function() { this.style.background = 'white'; this.style.borderColor = '#ccc'; };
	
	// Create OK button
	var okBtn = document.createElement('button');
	okBtn.textContent = 'OK';
	okBtn.style.cssText = 'padding: 10px 20px; border: 1px solid #007bff; background: #007bff; color: white; border-radius: 4px; cursor: pointer; font-size: 14px; min-width: 80px; font-weight: 500; transition: all 0.2s;';
	okBtn.onmouseover = function() { this.style.background = '#0056b3'; this.style.borderColor = '#0056b3'; };
	okBtn.onmouseout = function() { this.style.background = '#007bff'; this.style.borderColor = '#007bff'; };
	
	// Remove dialog function
	function removeDialog() {
		if (container.parentNode) {
			container.parentNode.removeChild(container);
		}
		if (overlay.parentNode) {
			overlay.parentNode.removeChild(overlay);
		}
	}
	
	// Button handlers
	cancelBtn.onclick = function() {
		removeDialog();
		if (onCancel) onCancel();
	};
	
	okBtn.onclick = function() {
		removeDialog();
		if (onConfirm) onConfirm();
	};
	
	// ESC key handler
	document.addEventListener('keydown', function escHandler(e) {
		if (e.keyCode === 27) { // ESC
			removeDialog();
			document.removeEventListener('keydown', escHandler);
			if (onCancel) onCancel();
		}
	});
	
	// Assemble dialog
	buttonContainer.appendChild(cancelBtn);
	buttonContainer.appendChild(okBtn);
	dialog.appendChild(messageEl);
	dialog.appendChild(buttonContainer);
	container.appendChild(dialog);
	
	// Add to document
	document.body.appendChild(overlay);
	document.body.appendChild(container);
	
	// Focus OK button
	okBtn.focus();
};




// WEBPACK FOOTER //
// ./app/helpers/custom-confirm.js